/**
 * Uses the `ReactNativeWebView` on the `window` to determine if user is navigating in a WebView.
 *
 * In the future, it can use extra data points to increase the probability
 * to determine if the mobile app is Vio.com mobile app or not.
 *
 * @returns A boolean indicating if the user is navigating in a WebView
 */

const isReactNativeWebView = (): boolean => {
  return Boolean(window.ReactNativeWebView) || Boolean(window.isReactNativeApp)
}

export {isReactNativeWebView}
